import { render } from "./course-form.vue?vue&type=template&id=f152baca&scoped=true"
import script from "./course-form.vue?vue&type=script&lang=js"
export * from "./course-form.vue?vue&type=script&lang=js"

import "./course-form.vue?vue&type=style&index=0&id=f152baca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f152baca"]])

export default __exports__